// LeyroChain marketplace SPA entry — chrome xa vive en <Layout>; aquí
// só montamos AuthProvider + Routes.

import { Link, Navigate, Route, Routes } from 'react-router-dom';

import ProtectedRoute from './auth/ProtectedRoute';
import Layout from './components/layout/Layout';
import { AuthProvider } from './context/AuthContext';
import AdminPage from './pages/AdminPage';
import AnimalDetailPage from './pages/AnimalDetailPage';
import EudrReceivedPage from './pages/EudrReceivedPage';
import BuyerConfirmationPage from './pages/BuyerConfirmationPage';
import CheckoutPage from './pages/CheckoutPage';
import LoginPage from './pages/LoginPage';
import MarketplacePage from './pages/MarketplacePage';
import DisputeOpenPage from './pages/DisputeOpenPage';
import MyPurchasesPage from './pages/MyPurchasesPage';
import BillingPage from './pages/BillingPage';
import CompliancePage from './pages/CompliancePage';
import ContactPage from './pages/ContactPage';
import FarmFormPage from './pages/FarmFormPage';
import HelpPage from './pages/HelpPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import InvoicesPage from './pages/InvoicesPage';
import ConversationView from './pages/ConversationView';
import KycPage from './pages/KycPage';
import MessagesPage from './pages/MessagesPage';
import PlansPage from './pages/PlansPage';
import PrivacyPage from './pages/PrivacyPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ProfilePage from './pages/ProfilePage';
import RolesPage from './pages/RolesPage';
import SecurityPage from './pages/SecurityPage';
import SellAnimalPage from './pages/SellAnimalPage';
import SetupPasswordPage from './pages/SetupPasswordPage';
import ShopCancelPage from './pages/ShopCancelPage';
import ShopPage from './pages/ShopPage';
import ShopSuccessPage from './pages/ShopSuccessPage';
import SitemapPage from './pages/SitemapPage';
import TermsPage from './pages/TermsPage';
import VerifyEmailPage from './pages/VerifyEmailPage';

export default function App(): JSX.Element {
  return (
    <AuthProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<MarketplacePage />} />
          <Route path="/marketplace" element={<MarketplacePage />} />
          <Route path="/marketplace/animal/:id" element={<AnimalDetailPage />} />
          <Route
            path="/marketplace/sales/:id/buyer-confirm"
            element={
              <ProtectedRoute>
                <BuyerConfirmationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketplace/checkout/:id"
            element={
              <ProtectedRoute>
                <CheckoutPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketplace/me/purchases"
            element={
              <ProtectedRoute>
                <MyPurchasesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketplace/sales/:saleId/dispute"
            element={
              <ProtectedRoute>
                <DisputeOpenPage />
              </ProtectedRoute>
            }
          />
          <Route path="/marketplace/login" element={<LoginPage />} />
          <Route path="/marketplace/verify-email" element={<VerifyEmailPage />} />
          <Route path="/marketplace/setup-password" element={<SetupPasswordPage />} />
          <Route path="/marketplace/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/marketplace/reset-password" element={<ResetPasswordPage />} />
          <Route path="/marketplace/vender" element={<SellAnimalPage />} />

          {/* Info pages */}
          <Route path="/marketplace/termos" element={<TermsPage />} />
          <Route path="/marketplace/privacidade" element={<PrivacyPage />} />
          <Route path="/marketplace/sitemap" element={<SitemapPage />} />
          <Route path="/marketplace/axuda" element={<HelpPage />} />
          <Route path="/marketplace/contacto" element={<ContactPage />} />
          <Route path="/marketplace/cumprimento" element={<CompliancePage />} />
          <Route path="/marketplace/seguridade" element={<SecurityPage />} />
          <Route path="/marketplace/plans" element={<PlansPage />} />
          {/* Lote V-9 — Shop LeyroSpot (kits NFC) vía Stripe Checkout. */}
          <Route
            path="/marketplace/shop"
            element={
              <ProtectedRoute>
                <ShopPage />
              </ProtectedRoute>
            }
          />
          {/* Stripe Checkout redirixe a /shop/success e /shop/cancel
              (URLs configuradas en env). Mantemos ambas paths. */}
          <Route path="/shop" element={<Navigate to="/marketplace/shop" replace />} />
          <Route path="/shop/success" element={<ShopSuccessPage />} />
          <Route path="/shop/cancel" element={<ShopCancelPage />} />
          <Route path="/marketplace/shop/success" element={<ShopSuccessPage />} />
          <Route path="/marketplace/shop/cancel" element={<ShopCancelPage />} />
          <Route
            path="/marketplace/facturacion"
            element={
              <ProtectedRoute>
                <BillingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketplace/facturas"
            element={
              <ProtectedRoute>
                <InvoicesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketplace/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketplace/kyc"
            element={
              <ProtectedRoute>
                <KycPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketplace/profile/roles"
            element={
              <ProtectedRoute>
                <RolesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketplace/profile/farm"
            element={
              <ProtectedRoute>
                <FarmFormPage />
              </ProtectedRoute>
            }
          />
          {/* Lote Admin-V1 — `/marketplace/admin` is the new tabbed panel
              (Dashboard, Settings, Anuncios, KYC). The legacy
              `kyc-review` route below stays as a permanent redirect for
              external bookmarks. */}
          <Route
            path="/marketplace/admin"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketplace/admin/kyc-review"
            element={<Navigate to="/marketplace/admin?tab=kyc" replace />}
          />
          <Route
            path="/marketplace/me/eudr"
            element={
              <ProtectedRoute>
                <EudrReceivedPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketplace/messages"
            element={
              <ProtectedRoute>
                <MessagesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketplace/messages/:id"
            element={
              <ProtectedRoute>
                <MessagesPage />
              </ProtectedRoute>
            }
          >
            <Route index element={<ConversationView />} />
          </Route>
          {/* Backwards-compat (Traefik may still route bare paths here). */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/setup-password" element={<SetupPasswordPage />} />

          <Route
            path="*"
            element={
              <div className="max-w-6xl mx-auto px-6 py-12 text-center text-muted">
                Páxina non atopada.{' '}
                <Link to="/marketplace" className="text-rauxa underline">
                  Volver ao marketplace
                </Link>
                .
              </div>
            }
          />
        </Routes>
      </Layout>
    </AuthProvider>
  );
}
